<div class="content-wrapper table-full-bx">
    <!-- End -->
    <div class="page-content recruiterpanel">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox">
                    <div class="ibox-body">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">  <a href="javascript:void(0);" (click)="backToJob()"> Jobs  </a> </li>
                            <li class="breadcrumb-item active"> Job Detail </li>
                        </ol>
                        <div class="row">
                            <div class="col-sm-12 col-lg-10 col-md-9">
                                <div class="basicbk">
                                    <div class="innertext">
                                        <p class="para6">{{allData?.JobPost?.newId || "-"}}</p>
                                        <h6 class="heading-6">{{allData?.JobPost?.jobTitle || "-"}}</h6>
                                    </div>
                                    <div class="innertext">
                                        <p class="para6">Location</p>
                                        <h6 class="heading-6" *ngIf="allData?.JobPost?.workPlaceLocation != 'Remote'">
                                            {{allData?.JobPost?.location || "-"}}
                                        </h6>
                                        <h6 class="heading-6" *ngIf="allData?.JobPost?.workPlaceLocation == 'Remote'">
                                            -
                                        </h6>
                                    </div>
                                    <div class="innertext">
                                        <p class="para6">Post date</p>
                                        <h6 class="heading-6">{{allData?.JobPost?.createdAt | date: "d/M/YYYY"}}</h6>
                                    </div>
                                    <div class="innertext">
                                        <p class="para6">Schedule</p>
                                        <h6 class="heading-6">{{allData?.JobPost?.schedulesName || "-"}}</h6>
                                    </div>
                                    <div class="innertext">
                                        <p class="para6">User</p>
                                        <h6 class="heading-6">{{allData?.recruiter?.name || "-"}}</h6>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-lg-2 col-md-3 ">
                                <div class="on-off">
                                    <div>
                                            <h6 class="heding-6">Position</h6>
                                            <p class="green" *ngIf="allData?.JobPost?.isBlocked==0">Open</p>
                                            <p class="green" *ngIf="allData?.JobPost?.isBlocked==1">Closed</p>
                                   </div>
                                        <label class="switch"  *ngIf="allData?.JobPost?.isBlocked==0">
                                            <input type="checkbox" [checked]="allData?.JobPost?.isBlocked==0" (change)="allData?.JobPost?.isBlocked==0">
                                            <span class="slider round" (click)="openModal(allData,jobStatus)"></span>
                                        </label>
                                        <label class="switch"  *ngIf="allData?.JobPost?.isBlocked==1"> 
                                            <span class="slider round" (click)="jobOpenStatus($event,allData?.JobPost?.id)"></span>
                                        </label>
                                </div>
                            </div>
                        </div>
                        <!-- Checkbox -->

                        <ul class="nav nav-pills job-list">
                            <li>
                                <a href="javascript:void(0)" (click)="redirectToApplicant()">Applicants</a>
                            </li>
                            <li>
                                <a href="javascript:void(0)" (click)="redirectToSuggestion()">Suggested candidates</a>
                            </li>
                            <li class="active">
                                <a href="javascript:void(0)">Details</a>
                            </li>

                        </ul>
                        <!-- searchbox -->

                        <div class="row align-items-baseline">
                            <div class="col-sm-3">
                                <div class="innerdes mt-0">
                                    <h6 class="heading-6">Work type</h6>
                                    <p class="para6">{{allData?.JobPost?.workPlaceLocation || "-"}}</p>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="innerdes mt-0">
                                    <h6 class="heading-6">Category</h6>
                                    <p class="para6">{{allData?.JobPost?.categoryName || "-"}}</p>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="innerdes mt-0 basicdetails ">
                                    <h6 class="heading-6">Specilization </h6>
                                    <p class="para6"><span *ngFor="let subcat of allData?.subCategory; let i=index;">{{subcat.subCategoryName}}</span></p>
                                </div>
                            </div> 
                            <a href="javascript:void(0)" class="editbtn mrt"  [routerLink]="'/jobs/edit/'" [queryParams]="{jobId:allData?.JobPost?.id }"><img src="assets/images/ic_edit.svg" class="ht">Edit</a>
                        </div>
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="innerdes">
                                    <h6 class="heading-6">Industries</h6>
                                    <p class="para6">{{allData?.JobPost?.industriesName || "-"}}</p>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="innerdes">
                                    <h6 class="heading-6">Employment type</h6>
                                    <p class="para6">{{allData?.JobPost?.EmploymentTypesName || "-"}}</p>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="innerdes">
                                    <h6 class="heading-6">Salary (USD)</h6>
                                    <p class="para6" *ngIf="allData?.JobPost?.price == null">$ {{allData?.JobPost?.minimum || "-"}} to $ {{allData?.JobPost?.maximum || "-"}} {{allData?.JobPost?.rate || "-"}}</p>
                                    <p class="para6" *ngIf="allData?.JobPost?.price != null">$ {{allData?.JobPost?.price || "-"}} {{allData?.JobPost?.rate || "-"}}</p>
                                    
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="innerdes">
                                    <h6 class="heading-6">Contact no.</h6>
                                    <p class="para6">{{allData?.JobPost?.countryCode}} {{allData?.JobPost?.phoneNumber || "-"}}</p>
                                </div>
                            </div>
                        </div>
                        <!-- end -->
                        <div class="innerdes">

                            <p class="para6">Description</p>
                            <h6 class="heading-6">{{allData?.JobPost?.description || "-"}}</h6>
                        </div>
                        <div class="innerdes">
                            <h6 class="heading-6">Skills</h6>
                            <ul class="addedskills" *ngIf="allData?.JobPostSkills != null">
                                <li *ngFor="let skill of allData?.JobPostSkills; let i=index;">{{skill?.skillsName}}</li>
                            </ul>
                            <span *ngIf="allData?.JobPostSkills == ''">-</span>

                        </div>
                        <div class="innerdes">
                            <h6 class="heading-6">Benefits</h6>
                            <ul class="addedskills" *ngIf="allData?.JobPostBenefits != null">
                                <li *ngFor="let ben of allData?.JobPostBenefits; let i=index;">{{ben?.benefitsName}}</li>
                            </ul>
                            <span *ngIf="allData?.JobPostBenefits == ''">-</span>

                        </div>

                        <div class="innerdes">
                            <h6 class="heading-6">Supplemental pay</h6>
                            <ul class="addedskills" *ngIf="allData?.supplementalPay != null">
                                <li *ngFor="let sup of allData?.supplementalPay; let i=index;">{{sup?.supplements_name}}</li>
                            </ul>
                            <span *ngIf="allData?.supplementalPay == ''">-</span>
                        </div>

                        <div class="innerdes">
                            <h6 class="heading-6">Number of positions</h6>
                            <ul class="jobdeslist">
                                <li><img src="assets/images/bullet.svg">{{allData?.JobPost?.noOfPeopleRequired || "-"}}</li>
                            </ul>
                        </div>


                        <div class="innerdes">
                            <h6 class="heading-6">Must haves</h6>
                            <ul class="jobdeslist">
                                <li><img src="assets/images/bullet.svg">Covid vaccine certificate required {{allData?.JobPost?.vaccinationCerificate ==  0 ? "- No" : "- Yes"}}</li>
                                <li><img src="assets/images/bullet.svg">Travel requirements {{allData?.JobPost?.travelRequirementsName || "-"}}</li>
                                <li><img src="assets/images/bullet.svg">This job is eligible for <strong  *ngIf="allData?.jobEligibleFor != ''" style="padding-left: 5px;"> <span *ngFor="let elg of allData?.jobEligibleFor"> {{elg.eligibles_name}}</span></strong> 
                                    <strong *ngIf="allData?.jobEligibleFor == ''"> -</strong>
                                </li>
                            </ul>
                        </div>

                        <div class="innerdes">
                            <h6 class="heading-6">Email Address</h6>
                            <ul class="jobdeslist email">
                                <li *ngIf="allData?.JobPostNotificationEmails != ''">
                                    <span *ngFor="let mail of allData?.JobPostNotificationEmails;" style="display: inline-block;vertical-align: middle;margin-right: 3px;"><img src="assets/images/bullet.svg"> {{mail.emailId || "-"}} </span>
                                </li>
                                <li *ngIf="allData?.JobPostNotificationEmails == ''"><img src="assets/images/bullet.svg">-</li>
                            </ul>
                        </div>
                        <!-- end -->
                    </div>

                </div>
            </div>
        </div>
    </div>

</div>
  
<ng-template #jobStatus>
    <div class="modal-body addModal text-left"> 
        <form [formGroup]="jobForm" (ngSubmit)="jobPostStatus()">
          <h4 class="uppercasetext">Are you sure you want to close this position?</h4> 
          <div class="form-group">
            <label>Reason for closing job</label>
            <textarea class="form-control p-0" placeholder="Please write here" formControlName="reason" maxlength="2000"></textarea>
            <p class="para5 text-left m-0">{{jobForm?.value?.reason?.length}}/2000</p>
            <div class="text-danger" *ngIf="jobForm.controls['reason'].hasError('required') && showError">
                *Please Enter reason.
            </div>
          </div>
          
          <div class="form-group"> 
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="customCheckBox1" formControlName="isNotify" [value]="1" [checked]="jobForm.value.isNotify == 1" (change)="jobForm.value.isNotify = 1">
                <label class="custom-control-label" for="customCheckBox1">Do you want to notify users?</label>
            </div>
          </div>
          <div class="d-flex">

            <div class="form-group"> 
              <a href="javascript:void(0);" class="planbtn greyBtn" (click)="modalRef?.hide()">Cancel</a>
              </div> 
          <div class="form-group"> 
            <input type="submit" value="Close position"  class="planbtn fill">
          </div>
          
        </div>
        </form>
  </div>
  </ng-template> 
 
 